import React, {Component} from 'react';

import {connect} from 'react-redux';
import HomeBookClubCardComponent from '../../components/bookclub/PublicBookClubCardComponent';
import {Card, Segment, Container, Divider, Header, Button} from 'semantic-ui-react';
import * as actionBookClubPublic from "../../redux/actions/bookClubPublic";
import ReactGA from 'react-ga';
import Analytics from "../../middleware/analytics";

class BookClubListIngContainer extends Component {
    state = {
        ingList: [],
        recruitList: [],
        endedList: []
    };
    componentDidMount = () => {
        this.props.loadBookClubList();
        Analytics.pageViewAll('/bookclub/list/ing')
        window.scrollTo(0, 0);
    };


    render() {
        const {
            bookClubListIng,
        } = this.props;
        const ingListSegment = () => {
            if (bookClubListIng.length === 0) {
                return '현재 진행중인 북클럽이 없습니다.';
            }
            return bookClubListIng.map((bookclub, i) => {
                return <HomeBookClubCardComponent bookclub={bookclub} key={i}/>;
            });
        };

        return (
            <div style={{marginTop: 50, marginBottom: 50, minHeight: '80vh'}}>
                <Segment as={Container} vertical basic>
                    <Header size={'large'}>
                        진행중 북클럽
                    </Header>
                    <Divider/>
                    <Card.Group itemsPerRow={3}
                                stackable>
                        {ingListSegment()}
                    </Card.Group>
                </Segment>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        bookClubListAll,
        bookClubListRecruiting,
        bookClubListIng,
        bookClubListEnded,
        isLoaded,
        failed
    } = state.bookClubPublic
    return {
        bookClubListAll,
        bookClubListRecruiting,
        bookClubListIng,
        bookClubListEnded,
        isLoaded,
        failed
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadBookClubList: () => {
            dispatch(actionBookClubPublic.loadBookClubList())
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BookClubListIngContainer);
